module.exports = __webpack_public_path__ + "img/signFailed.9366282a.png";